exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guide-tab-wrap[data-v-67457c78]{width:100%;height:17.066px;height:1.066667rem}.tab-ul[data-v-67457c78]{width:160px;width:10rem;height:17.066px;height:1.066667rem;color:#333}.tab-ul li[data-v-67457c78]{width:26.666px;width:1.66666667rem;height:100%;line-height:17.066px;line-height:1.066667rem;cursor:pointer}@media screen and (min-width:1025px){[pc=\"1\"] .tab-ul[data-v-67457c78]{font-size:0}[pc=\"1\"] .tab-ul li[data-v-67457c78]{font-size:18px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/data/efun/gw-template/client/smsgz/assets","/static":"/data/efun/gw-template/client/smsgz/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67457c78","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/smsgz/components/guide/guide-tab.vue
// module id = HgK3
// module chunks = 1